import { Fragment, useMemo } from 'react'
import { bezierCurve } from 'styles/tools/constants'
import { rem } from 'polished'
import styled from 'styled-components'
import useLastNonEmptyValue from 'hooks/useLastNonEmptyValue'
import clsx from 'clsx'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import { connect } from 'react-redux'
import ExperienceRecentlyViewedTile from 'components/Experiences/ExperienceTiles/ExperienceRecentlyViewedTile'
import useSelectedItems from '../hooks/useSelectedItems'

const EXPERIENCE_MAP_CAROUSEL_Z_INDEX = 1001

const CarouselContainer = styled.div`
  position: absolute;
  padding: 0 ${rem(16)};
  padding-bottom: ${rem(16)};
  bottom: 0;
  transform: translateY(100%);
  inset-inline: 0;
  z-index: ${EXPERIENCE_MAP_CAROUSEL_Z_INDEX};
  pointer-events: none;
  transition: transform .3s ${bezierCurve};
  width: 100%;

  &.show {
    pointer-events: auto;
    transform: translateY(0);
  }
`

interface MappedProps {
  experiences: Record<string, App.ExperienceOffer>
}

interface OwnProps {
  hidden?: boolean;
}

function ExperienceSearchMapCarousel(props: MappedProps & OwnProps) {
  const { experiences, hidden } = props
  const { selectedItemsIds } = useSelectedItems()

  // Holds the last selected offer IDs, so we can keep showing them while the carousel transitions out of the viewport
  const lastSelectedOfferIds = useLastNonEmptyValue(selectedItemsIds)
  const mappedExperiences = useMemo(() => lastSelectedOfferIds?.map(id => experiences[id]), [lastSelectedOfferIds, experiences])
  const selectedItemCount = selectedItemsIds?.length ?? 0

  return (
    <CarouselContainer className={clsx({ show: selectedItemCount > 0 && !hidden })}>
      <CardCarousel width={rem(470)} alignment="center">
        {mappedExperiences?.map(experience => <Fragment key={experience?.id}>
          <ExperienceRecentlyViewedTile experience={experience} isMapView />
        </Fragment>)}
      </CardCarousel>
    </CarouselContainer>
  )
}

const mapStateToProps = (state: App.State) => ({
  experiences: state.experience.experiences,
})

export default connect(mapStateToProps)(ExperienceSearchMapCarousel)
